import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';

import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Paper from '@material-ui/core/Paper';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Typography from '@material-ui/core/Typography';
import CatalogInfo from './CatalogInfo';
import Button from '@material-ui/core/Button';

//Progress
import CircularProgress from '@material-ui/core/CircularProgress';
import {
  CREATE_PROJECT_MODEL_ACTION_CREATE,
  CREATE_PROJECT_MODEL_ACTION_EDIT,
  CREATE_PROJECT_MODEL_ACTION_SHOW
} 
from '../common/redux/constantes';

//validators
import {validateField} from '../common/redux/validators';


const styles = theme => ({
  appBar: {
    position: 'relative',
  },
  layout: {
    width: 'auto',
    marginLeft: theme.spacing.unit * 2,
    marginRight: theme.spacing.unit * 2,
    [theme.breakpoints.up(600 + theme.spacing.unit * 2 * 2)]: {
      width: 600,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing.unit * 3,
    marginBottom: theme.spacing.unit * 3,
    padding: theme.spacing.unit * 2,
    [theme.breakpoints.up(600 + theme.spacing.unit * 3 * 2)]: {
      marginTop: theme.spacing.unit * 6,
      marginBottom: theme.spacing.unit * 6,
      padding: theme.spacing.unit * 3,
    },
  },
  stepper: {
    padding: `${theme.spacing.unit * 3}px 0 ${theme.spacing.unit * 5}px`,
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginTop: theme.spacing.unit * 3,
    marginLeft: theme.spacing.unit,
  },
});

const steps = [
  'Phase', 
];

class CreateCatalog extends Component {
 

  constructor(props)
  {
    super(props);

    //Bindings
    this.handleChange=this.handleChange.bind(this);
    this.saveCatalog=this.saveCatalog.bind(this);

    //Primer estado
    let catalog = {
      name:'',
    };
    let activeStep = 0;
    
    //Si está editando o viendo la info
    if(this.props.actionDialog !== CREATE_PROJECT_MODEL_ACTION_CREATE)
    {
      catalog = this.props.catalogEdit;
      this.setState({catalog:catalog});
    }

    this.state = {
      activeStep: activeStep,
      catalog:catalog,
      errores:{}
    }; 
  }

  getStepContent(step) 
  {
    switch (step) {
      case 0:
        return <CatalogInfo handleChange={this.handleChange} errores={this.state.errores} catalog={this.state.catalog} reviewActive={(this.props.actionDialog === CREATE_PROJECT_MODEL_ACTION_SHOW )}/>;
      default:
        throw new Error('Unknown step');
    }
  }

   handleNext = () => {
    if(steps.length - 1 === this.state.activeStep && this.props.actionDialog!==CREATE_PROJECT_MODEL_ACTION_SHOW)
    {
      //Solo puede guardar si está valido el form
      if(!this.validateForm())
      {
        return;
      }

      //Si es el último step hay que guardar el project. 
      this.saveCatalog();
    }
    else if(steps.length - 1 === this.state.activeStep)
    {
      //Por petición se hizo que si está sólo mostrando datos en el botón next se cierre la pantalla.
      this.props.onCloseAction();
      return;
    }

    this.setState(state => ({
      activeStep: state.activeStep + 1,
    }));
  };


  handleBack = () => {
    this.setState(state => ({
      activeStep: state.activeStep - 1,
    }));
  };

  handleChange(event) {
    //Si sólo se está mostrando la información no cambia nada.
    if(this.props.actionDialog === CREATE_PROJECT_MODEL_ACTION_SHOW )
      return;

    const target = event.target;
    const value = target.value;
    const name = target.id? target.id:target.name;
    let catalog = this.state.catalog;
    catalog[name] = value;

    this.validateForm();

    this.setState({
      catalog: catalog,
    });
    this.validateForm();
  }

  validateForm = ()=>{
    let errores = {};
    let valido = true;
    let catalog = {
      name:'',
    };

    //Validando atributos almenos ingresados
    for (const attribute in catalog) 
    {
      if (!validateField(this.state.catalog[attribute])) 
      {
        errores[attribute]= 'Please enter the required fields';
        valido = false;
      }
    }


    this.setState({
      errores: errores,
    });
    return valido;
  }

  saveCatalog()
  {
    this.props.actions.saveCatalog(this.state.catalog,this.props.actionDialog );
  }

  handleReset = () => {
    this.setState({
      activeStep: 0,
    });
  };

  render() {
    const { classes } = this.props;
    const {savePending, fragmentContent,fragmentTitle } = this.props.dc;
    const {activeStep} = this.state;
    let title = "Catalog Information";
    if(this.props.actionDialog===CREATE_PROJECT_MODEL_ACTION_CREATE){
      title =  "Create Catalog";
    }else if (this.props.actionDialog===CREATE_PROJECT_MODEL_ACTION_EDIT){
      title = "Update Catalog";
    }
    return (
      <React.Fragment>
        <CssBaseline />
        <main className={classes.layout}>
          <Paper className={classes.paper}>
            <Typography component="h1" variant="h4" align="center">
              {title}
            </Typography>
            <Stepper activeStep={activeStep} className={classes.stepper}>
              {steps.map(label => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>
            <React.Fragment>
              {activeStep === steps.length ? (
                <div>
                  {savePending ? 
                  (
                    <CircularProgress />
                  ):(
                    <React.Fragment>
                      <Typography variant="h5" gutterBottom>
                        {fragmentTitle}
                      </Typography>
                      <Typography variant="subtitle1">
                      {fragmentContent}
                      </Typography>
                    </React.Fragment>
                  )}
                </div>
              ) : (
                <React.Fragment>
                  {this.getStepContent(activeStep)}
                  <div className={classes.buttons}>
                    {(activeStep !== 0) && (
                      <Button
                        onClick={this.handleBack}
                        className={classes.button}
                      >
                        Back
                      </Button>
                    )}
                    {(true) && (
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={this.handleNext}
                        className={classes.button}
                      > 
                        {activeStep === steps.length - 1 ? this.props.actionDialog===CREATE_PROJECT_MODEL_ACTION_SHOW? "Close":"Save" : "Next"}
                      </Button>
                    )}
                  </div>
                </React.Fragment>
              )}
            </React.Fragment>
          </Paper>
        </main>
      </React.Fragment>
    );
  }
}

CreateCatalog.propTypes = {
  classes: PropTypes.object.isRequired,
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    dc: state.dc,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(CreateCatalog));



// WEBPACK FOOTER //
// ./src/features/dc/CreateCatalog.js